import type { Theme } from '@mui/material/styles';

export function simpleLayoutVars(theme: Theme) {
    return {
      '--layout-simple-content-compact-width': '448px',
      '--layout-nav-background-image': (theme.palette as any).backgroundImage,
    };
  }